import Cookies from "js-cookie";

  export default function cookiePopup() {
    // Cookies
    const cookieAccepted = "COOKIES_AGREEMENT";
    const cookieRejected = "COOKIES_REJECTED";
    const isCookiesAccepted = Cookies.get(cookieAccepted);
    const isCookiesRejected = Cookies.get(cookieRejected);

    const domain = window.location.hostname;

    // UI Elements
    const popup = document.querySelector(".popup-cookie");
    const isTop = popup.classList.contains('popup-cookie--top');
    const popupText = document.querySelector(".popup-cookie .popup-text");
    const textWrapper = document.querySelector(".popup-cookie__column--description");
    const readMore = document.querySelector(".popup-readmore--more");
    const readLess = document.querySelector(".popup-readmore--less");

    // Triggers
    const accept = document.querySelector(".js-popup-accept");
    const close = document.querySelector(".js-popup-close");

    function accepted() {
      Cookies.set(cookieAccepted, "true", { expires: 30, domain: domain });
      if (isTop) {
        popup.classList.remove('is-visible--top');
      } else {
        popup.classList.remove('is-visible');
      }
      popup.removeAttribute("style");
    }

    function autoConfirmed() {
      Cookies.set(cookieRejected, "true", { expires: 0.02, domain: domain });
        if (isTop) {
          popup.classList.remove('is-visible--top');
        } else {
          popup.classList.remove('is-visible');
        }
        popup.removeAttribute("style");
    }

    if (!isCookiesAccepted && !isCookiesRejected) {
      if (isTop) {
        popup.classList.add('is-visible--top');
      } else {
        popup.classList.add('is-visible');
      }
    }

    accept.addEventListener('click', () => {
      accepted();
    });

    close.addEventListener('click', () => {
      autoConfirmed();
    });

    readMore.addEventListener('click', () => {
      popupText.classList.add('is-visible');
      textWrapper.classList.add('is-open');
      readMore.style.display = 'none';
      readLess.style.display = 'inline';

      console.log('text:', popupText);
    });

    readLess.addEventListener('click', () => {
      popupText.classList.remove('is-visible');
      textWrapper.classList.remove('is-open');
      readMore.style.display = 'inline';
      readLess.style.display = 'none';
    });

    // Hide the cookie banner outside the viewport
    // if (isTop) cookieBanner.style.top = '-100%';

    
    // // Show the cookie banner
    // setTimeout(() => {
    //   if (cookieBanner)
    //   cookieBanner.style.transition = 'top 0.5s ease-in-out';
    //   cookieBanner.style.top = '0';
    // }, 1000);

    // function topPopupHack() {
    //   const pageHeaderHeight = header.offsetHeight;
    //   const smartappBanner = document.querySelector(".smartbanner");
    //   const smartappBannerHeight = smartappBanner.offsetHeight;
    //   const bannerHeaderHeight = bannerHeader.offsetHeight;
    //   const scroll = $(window).scrollTop();
    //   let offset;

    //   if (
    //     !isCookiesAccepted &&
    //     !isCookiesRejected &&
    //     window.cookiesPrivacyData.showPopUp &&
    //     popup.hasClass(IS_VISIBLE)
    //   ) {
    //     offset = header.outerHeight();

    //     if (bannerHeader.length) {
    //       offset = offset + bannerHeaderHeight;
    //     }

    //     if (smartappBanner.length) {
    //       offset = offset + smartappBannerHeight;
    //     }

    //     if ($(window).width() < DESKTOP) {
    //       if (scroll > 0) {
    //         popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
    //       } else if (bannerHeader.length || smartappBanner.length) {
    //         popup.css("transform", `translateY(${offset}px)`);
    //         if (bannerHeader.hasClass(CLASSES.IS_HIDDEN)) {
    //           popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
    //         }

    //         if (!$(".smartbanner-show").length) {
    //           popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
    //         }
    //       } else {
    //         popup.css("transform", `translateY(${pageHeaderHeight}px)`);
    //       }

    //       bannerHeader.find(".banner-close").click(() => {
    //         popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
    //       });

    //       $(".smartbanner-close").click(() => {
    //         popup.css("transform", `translateY(${pageHeaderHeight + 16}px)`);
    //       });
    //     } else {
    //       if (scroll > 0) {
    //         popup.css("transform", `translateY(${pageHeaderHeight}px)`);
    //       } else if (bannerHeader.length) {
    //         popup.css("transform", `translateY(${offset}px)`);

    //         if (bannerHeader.hasClass(CLASSES.IS_HIDDEN)) {
    //           popup.css("transform", `translateY(${pageHeaderHeight - 16}px)`);
    //         }
    //       } else {
    //         popup.css("transform", `translateY(${pageHeaderHeight - 16}px)`);
    //       }

    //       bannerHeader.find(".banner-close").click(() => {
    //         popup.css("transform", `translateY(${pageHeaderHeight - 16}px)`);
    //       });
    //     }
    //   }
    // }
  }


